/**
 * Copyright (c) 2025-2026 Four Hour Window LLC
 * All rights reserved.
 * 
 * This source code is proprietary and confidential.
 * Unauthorized copying, distribution, or use is strictly prohibited.
 */

import React from 'react';

const KnowledgeCenter: React.FC = () => {
  return (
    <div className="page-container">
      <h1>Knowledge Center</h1>
      <div className="content-card">
        <h2>Resources & Documentation</h2>
        <div className="knowledge-sections">
          <div className="knowledge-item">
            <h3>📚 Getting Started</h3>
            <p>Learn the basics of using Merch Sherpa</p>
          </div>
          <div className="knowledge-item">
            <h3>📊 Sales Analytics</h3>
            <p>Understanding your sales dashboard</p>
          </div>
          <div className="knowledge-item">
            <h3>🛍️ Product Management</h3>
            <p>How to manage your products effectively</p>
          </div>
          <div className="knowledge-item">
            <h3>❓ FAQ</h3>
            <p>Frequently asked questions</p>
          </div>
        </div>
        <p style={{ marginTop: '20px', color: '#666' }}>
          Full knowledge base and tutorials coming soon...
        </p>
      </div>
    </div>
  );
};

export default KnowledgeCenter;